import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { permissionChecker } from "../../Helpers/permissionChecker";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import { BackdropLoading } from "../Common/BackdropLoading";
import { PlaceholderSkeleton } from "../Common/PlaceholderSkeleton";
import { UserContext } from "../UserContext";
import { DoorCard } from "./DoorCard";

export const ListDoors = () => {
	const { handleTitle, selectedLocation } = useContext(UserContext);

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [doors, setDoors] = useState([]);
	const [accessRequests, setAccessRequests] = useState([]);
	const [loading, setLoading] = useState(true);

	const hasPermission = permissionChecker({
		selectedLocation,
		permission: 1
	});

	if (!hasPermission) navigate("/locations");

	const fetchDoors = () => {
		setLoading(true);

		if (
			selectedLocation !== null
		) {
			ApiCall(
				"GET",
				"client/doors/" + selectedLocation.id,
				null
			)
				.then((res) => {
					setDoors(res);
					setLoading(false);
				}).catch((err) => {
					console.log(err);
					setLoading(false);
				});
		}
		ApiCall("GET", "client/access_requests")
		.then((res) => {
			setAccessRequests(res);
			  }).catch((err) => {
				console.log(err);
			  })
	};

 	const getAccessRequestCountForDoor = (doorId) => {
		return accessRequests.filter((request) => request.door.id === doorId).length;
	}

	useEffect(() => {
		setDoors([]);
		setAccessRequests([]);
		fetchDoors();
	}, [selectedLocation]);

	useEffect(() => {
		handleTitle(t("common.doors"));
	}, []);

	return (
		<Box>
			<Stack sx={{ alignItems: isMobile ? "center" : undefined }}>
				{loading && <BackdropLoading />}
				{!loading && doors.length === 0 && (
					<Typography
						sx={{
							fontSize: "20px",
							fontWeight: "700",
							color: ColorScheme.white,
							textAlign: isMobile ? "center" : undefined
						}}
					>
						{doors.length == 0 && !loading ? (
							t("doors.not_found")
						) : (
							<PlaceholderSkeleton isLarge showLoading />
						)}
					</Typography>
				)}
				{!loading && doors.length > 0 && (
					<div
						style={{
							width: isMobile ? undefined : "100%",
							flexDirection: isMobile ? "column" : "row",

							justifyContent: isMobile ? "center" : undefined,
							display: "flex",
							flexWrap: "wrap",
							flex: 1,
							gap: "15px"
						}}
					>
						{doors.map((door, index) => (
							<DoorCard
								newRequests={getAccessRequestCountForDoor(door.id)}
								fetchDoors={fetchDoors}
								key={index}
								data={door}
							/>
						))}
					</div>
				)}
			</Stack>
		</Box>
	);
};
